export default [
  {
    path: '/elective/student',
    name: 'PageElectiveStudent',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveStudent'
      ),
    meta: {
      modular: 44,
      title: '选修课',
      keepAlive: true,
      info: '选修课——首页'
    }
  },
  {
    path: '/elective/activity',
    name: 'PageElectiveActivity',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveActivity'
      ),
    meta: {
      modular: 44,
      title: '选课活动',
      keepAlive: true,
      info: '选修课——选课活动'
    }
  },
  {
    path: '/elective/activity/course',
    name: 'PageElectiveActivityCourse',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveActivityCourse'
      ),
    meta: {
      modular: 44,
      title: '选修班',
      keepAlive: true,
      info: '选修课——选修班'
    }
  },
  {
    path: '/elective/course/details',
    name: 'PageElectiveCourseDetails',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveCourseDetails'
      ),
    meta: { modular: 44, title: '选修班', info: '选修课——选修班' }
  },
  {
    path: '/elective/teacher',
    name: 'PageElectiveTeacher',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveTeacher'
      ),
    meta: {
      modular: 44,
      title: '选修课',
      keepAlive: true,
      info: '选修课——老师首页'
    }
  },
  {
    path: '/elective/course/members',
    name: 'PageElectiveCourseMembers',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/elective/PageElectiveCourseMembers'
      ),
    meta: { modular: 44, title: '课程详情', info: '选修课——课程详情' }
  }
]
